import React from 'react';
import {PhotoGallery as PG} from 'FW/Models/PhotoGallery';
import _ from 'underscore';
import Pagination from 'react-js-pagination';

let HelperHtml = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>

        <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
                <div class="pswp__counter"></div>
                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                <button class="pswp__button pswp__button--share" title="Share"></button>
                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>
            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>
            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>
            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>
        </div>
    </div>
</div>`;

class PhotoGallery extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = this.getStateFromProps(props);
    this.processItems = this.processItems.bind(this);
    this.addButtonToSection = this.addButtonToSection.bind(this);
    this.editGallery = this.editGallery.bind(this);
    this.state.photos.setPageSize(props.section.prop('page_size') || 20,() => {
      this.processItems();
      this.forceUpdate();
    });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.processItems(newProps);
    this.setState(this.getStateFromProps(newProps));
  }

  componentDidUpdate() {
    if (FW.inEditor()) {
      this.addButtonToSection();
    }
  }

  addButtonToSection() {
    let section = this.props.section;
    let user = window.parent.FW.store.get('user')
      ? window.parent.FW.store.get('user')
      : null;
    if (
      this.state.gallery &&
      this.state.gallery.get('created_at') &&
      user &&
      user.may('edit_photo_gallery', this.state.gallery)
    ) {
      section._editButtons = [
        {
          title: 'Edit Gallery',
          class: 'glyphicon-picture',
          type: 'btn-default',
          action: this.editGallery
        }
      ];
    }
  }

  editGallery() {
    window.parent.FW.editor.setMode('editGallery', 'editGallery', {
      gallery: this.state.gallery,
      remount: true,
      onSave: () => {
        this.props.section.reboot();
      }
    });
  }

  getStateFromProps(props) {
    let gallery = PG.findOrCreate({id: props.section.prop('photo_gallery_id')});
    let photos = gallery.get('photos');
    photos.sortField = 'gallery_order_id';
    photos.sortOrder = 'ASC';
    return {
      gallery: gallery,
      photos: photos
    };
  }

  processItems() {
    this._items = [];
    _.each(this.state.photos.sortBy('gallery_order_id'), photo => {
      this._items.push({
        src: photo.helper.thumbnailUrl(2880),
        raw: photo.originalUrl(),
        w: photo.get('details').width,
        h: photo.get('details').height,
        title: photo.get('title'),
        description: photo.get('description'),
        msrc: photo.helper.thumbnailUrl(800)
      });
    });
  }

  componentDidMount() {
    if ($('.pswp').length === 0) {
      $(HelperHtml).appendTo('body');
    }
  }

  openGallery(i) {
    require(/* webpackPrefetch: true */ [
      'photoswipe/dist/photoswipe',
      'photoswipe/dist/photoswipe-ui-default',
      'photoswipe/dist/photoswipe.css',
      'photoswipe/dist/default-skin/default-skin.css'
    ], (PhotoSwipe, PhotoSwipeUi) => {
      global.PhotoSwipe = PhotoSwipe;
      global.PhotoSwipeUi = PhotoSwipeUi;
      let g = new PhotoSwipe($('.pswp')[0], PhotoSwipeUi, this._items, {
        shareButtons: [
          {id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}'},
          {id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'},
          {id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'},
          {id:'download', label:'Download Image', url:'{{source_image_url}}', download:true}
        ],
        getThumbBoundsFn: index => {
          let el = $(
            this.props.section.element().find('.photo-gallery-photo')[index]
          );
          return {x: el.offset().left, y: el.offset().top, w: el.width()};
        },
        addCaptionHTMLFn: (item, captionEl) => {
          if (!item.title) {
            captionEl.children[0].innerHTML = '';
            return false;
          }
          let description = item.description || '';
          captionEl.children[0].innerHTML =
            '<div><span class="author" style="font-weight: bold;">' +
            item.title +
            '</span><br /><span class="description">' +
            description.replace(/\n/g, '<br />') +
            '</span></div>';
          return true;
        },
        index: i
      });
      g.init();
    });
  }

  handlePageChange = page => {
    this.state.photos.getPage(page, () => {
      this.processItems();
      this.setState({
        activePage: page
      });
    });
  };

  render() {
    let pagination = this.state.photos.pagination
      ? this.state.photos.pagination
      : {};

    let photos = this.state.photos
      .sortBy('gallery_order_id')
      .map((photo, i) => {
        let src = photo.helper.thumbnailUrl(800);
        return (
          <div
            key={`photo-${photo.get('id')}`}
            style={{width: '24%', paddingLeft: '.5%', paddingRight: '.5%'}}
            onClick={this.openGallery.bind(this, i)}
          >
            <img
              src={src}
              style={{width: '100%'}}
              data-id={photo.get('id')}
              className="photo-gallery-photo thumbnail"
            />
            {this.state.gallery.get('display_titles') ? <h4>{photo.get('title')}</h4> : null}
          </div>
        );
      });

    let filler = (
      <div style={{textAlign: 'center', paddingTop: 75, width: '100%'}}>
        {this.state.gallery.get('site_id') ? (
          <span>
            <p className="lead">No photos have been added to this gallery.</p>
            <p>
              <span className="btn btn-default" onClick={this.editGallery}>
                Add Photos
              </span>
            </p>
          </span>
        ) : (
          <span>
            <p className="lead" style={{paddingTop: 25}}>
              Gallery Not Found. Edit this section and select a gallery.
            </p>
          </span>
        )}
      </div>
    );

    return (
      <div
        className="photo-gallery"
        style={{
          display: 'flex',
          width: '100%',
          flexFlow: 'row wrap',
          minHeight: 200
        }}
      >
        {photos.length > 0 ? photos : filler}
        <div style={{width: '100% ', textAlign: 'center'}}>
          <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={pagination.size || 10}
            totalItemsCount={pagination.total || 10}
            pageRangeDisplayed={15}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

export default PhotoGallery;
